export default __webpack_public_path__ + "static/mat-6c821289da014f4cc5fce9fb7cc3f5f0.svg";